module.exports = __webpack_public_path__ + "static/media/gift_card.eadcfc89.png";